import React from 'react';
import {Link} from 'react-router-dom'
import {Loading} from '../../custom/LoadingComponent'

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box'
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';


function Equipment(props) {

    if (props.equipment.isLoading) {
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
                <Loading />
            </Box>
            </Container>
        );
    }
    else { 
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>

                <Stack spacing={1} sx={{marginBottom: 2}}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            <Link to="/home">Acasa</Link>
                            <Typography color="text.primary">Instalatii</Typography>
                        </Breadcrumbs>
                    </Box>

                    <Box>
                        <Box style={{display:"flex", marginBottom: 4}}>
                            <h3>Instalatii</h3>
                            <Box sx={{ width:'100%'}} display="flex" justifyContent="flex-end" alignItems="flex-end">
                                <Link to={'/newequipment'}>
                                    <Button variant="outlined" sx={{ marginRight: 0.5, marginTop: 0.5 }} >Adauga Echipament</Button>
                                </Link>
                            </Box>
                        </Box>                
                    </Box>
                    <hr />

                    <br/>
                    In dezvoltare.....
                </Stack>

            </Box>
            </Container>
        );
    }
}

export default Equipment;